<template>
<div class="pl20 pr20 mt-6">
  <div v-if="campaigns.length" class="sites-or-pages-container">
    <div class='site-page-card' v-for="c in campaigns" :key="c.id">
      <div class="top-part border-bottom d-flex align-center">
        <span class="d-flex align-center flex-gap-10">
          <span class="material-icons pin-icon tooltip" :class="{ 'pinned': c.isPinned }"
            :data-tooltip="c.isPinned ? 'Click to unpin' : 'Pin this Page to the top of your dashboard to find it easily.'"
            @click="() => {
              // pinPageSettingAction(c.id, !c.isPinned)
            }">push_pin</span>
          <span class="pagerun-type">{{ c.isDomainLevelCampaign ? 'Domain level' : 'Page level' }}</span>
        </span>
        <div class="flex-grow-1"></div>
        <div>
          <v-btn icon :id="`dot-menu-for-${c.id}`">
            <span class="material-icons-outlined mainColor--text">more_horiz</span>
          </v-btn>
          <v-menu
            :activator="`#dot-menu-for-${c.id}`"
            bottom offset-y>
            <v-list>
              <!-- <v-list-item link @click="enterPageSetting(c)">
                <v-list-item-title
                  class="mainColor--text">
                  Page setting
                </v-list-item-title>
              </v-list-item>
              <v-list-item link @click="displayDeletePageConfirmModal(c.id)">
                <v-list-item-title
                  class="mainColor--text">
                  Delete
                </v-list-item-title>
              </v-list-item> -->
            </v-list>
          </v-menu>
        </div>
      </div>
      <div class="main-part">
        <div class="flex-grow-1">
          <div class="mt-3 mainColor--text font-weight-regular">Date created: {{ c.createdAt }}</div>
          <div class="mt-3 project-name font-weight-bold">{{ c.isDomainLevelCampaign ? 'Domain level' : c.campaignName }}</div>
          <div class="mt-3 mainColor--text font-weight-regular">Recent enquiries</div>
          <div class="pages-wrapper mt-3">
            <div class="page-item" @click="() => {
              $router.push(`/sites/${ siteId }/campaign/${ c.id }`)
            }">
              <div class="flex-grow-1">
                <div class="name">Keyword insight</div>
                <div class="time">{{ toLocalDateTimeString(c.createdAt) }}</div>
              </div>
              <div class="action">
                <i class="material-icons-outlined" @click="() => {}">arrow_circle_right</i>
              </div>
            </div>
            <div class="page-item" @click="() => {}">
              <div class="flex-grow-1">
                <div class="name">Keyword tracking</div>
                <div class="time">{{ '' }}</div>
              </div>
              <div class="action">
                <i class="material-icons-outlined" @click="() => {}">arrow_circle_right</i>
              </div>
            </div>
            <div class="page-item" @click="() => {}">
              <div class="flex-grow-1">
                <div class="name">Keyword wizard</div>
                <div class="time">{{ '' }}</div>
              </div>
              <div class="action">
                <i class="material-icons-outlined" @click="() => {}">arrow_circle_right</i>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

  <div
    v-else-if="showEmptyState"
    class="silo-container-empty silo-container-empty--stacked mb-5"
  >
    <div class="silo-structure-empty-container">
      <img src="/static/silo-structure.svg" class="silo-structure" alt="" />
    </div>
    <div class="silo-text-empty-container">
      <div class="step-title" style="text-align: left; width: 100%; font-size: 1.1rem;">Create your first Keyword Research report</div>
      <div class="title-text" style="text-align: left;">
        POP Keyword Research provides key metrics for keywords in your project and helps you
        decide what terms to target. Check search volume and find low-competition keywords with ease.
      </div>
      <div class="gap1">
        <v-btn
          @click="gotoKeywordInsight"
          rounded
          color="anchor1Color"
          class="text-none whiteColor--text font16 padding8 height38 button-with-icon"
        >
          <i class="material-icons mr-1">auto_awesome</i>
          <span>Start Keyword Research</span>
        </v-btn>
      </div>
    </div>
  </div>

</div>
</template>

<script>
import { toLocalDateTimeString } from '@/utils'

export default {
  data () {
    return {
      campaigns: [],
      campaignsFetchDone: false,
    }
  },
  computed: {
    siteId () {
      return this.$route.params.siteId;
    },
    showEmptyState () {
      return this.campaignsFetchDone && !this.campaigns.length;
    },
  },
  watch: {
    showEmptyState (visible) {
      this.$emit('empty-state-visible', visible);
    },
  },
  methods: {
    toLocalDateTimeString (d) {
      return toLocalDateTimeString(d)
    },
    defaultCampaignPageId () {
      const pages = this.$store.getters.siteById(Number.parseInt(this.siteId, 10))?.pages || [];
      const pinned = pages.find((p) => p.isPinned);
      if (pinned) {
        return pinned.id;
      }
      return pages[0]?.id;
    },
    gotoKeywordInsight () {
      const campaignId = this.defaultCampaignPageId();
      if (campaignId) {
        this.$router.push(
          `/sites/${this.siteId}/campaign/${campaignId}/keyword-insight`,
        );
        return;
      }
      this.$router.push({
        path: `/sites/${this.siteId}/pages`,
        query: { tab: 'keyword-research' },
      });
    },
    loadCampaigns () {
      this.$store.dispatch('getCampaignsForSite', this.siteId)
        .then((response) => {
          if (response.data && response.data.status === 'SUCCESS') {
            this.campaigns = response.data.campaigns
          }
        })
        .finally(() => {
          this.campaignsFetchDone = true;
        });
    }
  },
  mounted () {
    this.loadCampaigns()
  }
}
</script>

<style lang="scss" scoped>
@import '@/components/Campaigns/silo/silo.scss';
</style>
